<div *ngIf="displayIdl">
    <div class="swal2-container swal2-center swal2-backdrop-show">
        <div
            class="swal2-popup swal2-modal swal2-show contener-view"
            tabindex="-1"
            role="dialog"
            aria-live="assertive"
            aria-modal="true"
            style="display: flex">
            <div class="swal2-header">
                <button class="view_btn-close" (click)="closeReport()">
                    <i class="fas fa-times"></i>
                </button>
                <h2
                    class="swal2-title modal_mensaje"
                    id="swal2-title"
                    style="display: flex">
                    {{ 'reporte.tituloFechaReporteIndividual' | translate }}
                </h2>

                <div class="options_date">
                    <div class="select-container">
                        <label for="selectedYear">Año a reportar</label>
                        <select
                            [(ngModel)]="selectedYear"
                            (change)="onYearChange()">
                            <option *ngFor="let year of years" [value]="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>
                    <div class="select-container">
                        <label for="selectedMonth">Mes a reportar</label>
                        <select [(ngModel)]="selectedMonth">
                            <!-- Aquí puedes agregar opciones para los meses -->
                            <option
                                *ngFor="let month of months"
                                [ngValue]="month">
                                {{ month.name }}
                            </option>
                        </select>
                    </div>
                    <div
                        *ngIf="errorMessages.length > 0"
                        class="modal_error-message">
                        <p *ngFor="let error of errorMessages">{{ error }}</p>
                    </div>
                </div>
                <button type="button" class="btn_upload" (click)="pageReport()">
                    Crear Reporte
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Ventana de confirmacion -->
<div *ngIf="displeyIdlConfirm">
    <div class="swal2-container swal2-center swal2-backdrop-show">
        <div
            class="swal2-popup swal2-modal swal2-show centrar"
            tabindex="-1"
            role="dialog"
            aria-live="assertive"
            aria-modal="true"
            style="display: flex">
            <div class="swal2-header view_conteiner-alert">
                <button class="view_btn-close" (click)="volverConfirm()">
                    <i class="fas fa-times"></i>
                </button>
                <h2
                    class="swal2-title titlre-confirm"
                    id="swal2-title"
                    style="display: flex">
                    {{ mensajeConfirm }}
                </h2>
                <div class="conteinerbts-confirm">
                    <button
                        type="button"
                        class="view_btn-alert"
                        (click)="continuar()">
                        Continuar
                    </button>
                    <button
                        type="button"
                        class="view_btn-alert"
                        (click)="volverConfirm()">
                        {{ nombreBtn }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
